var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{staticClass:"min-vh-100"}),_c('b-sidebar',{attrs:{"id":"sidebar-menu","shadow":"","no-header":"","width":"100vw"}},[[_c('Menu')]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }